import { render } from "./WidgetCredentials.vue?vue&type=template&id=680cf4dd&scoped=true"
import script from "./WidgetCredentials.vue?vue&type=script&lang=js"
export * from "./WidgetCredentials.vue?vue&type=script&lang=js"

import "./WidgetCredentials.vue?vue&type=style&index=0&id=680cf4dd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680cf4dd"]])

export default __exports__